const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)')

class CoverVideo {
  constructor (element) {
    this.element = element
    this.hideBelow = element.getAttribute('data-hide-below')
    this.mobile = this.hideBelow ? window.matchMedia(`(max-width: ${this.hideBelow}px)`) : null
    this.loaded = false
    this.inView = false

    REDUCED_MOTION.addEventListener('change', () => this.update())
    if (this.mobile) {
      this.mobile.addEventListener('change', () => this.update())
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        this.inView = entries[0].isIntersecting
        this.update()
      }).observe(element)
    } else {
      this.inView = true
      this.update()
    }
  }

  isAllowed () {
    return !REDUCED_MOTION.matches && !(this.mobile && this.mobile.matches)
  }

  shouldPlay () {
    return this.inView && this.isAllowed()
  }

  update () {
    if (this.shouldPlay()) {
      if (!this.loaded) {
        this.load()
      }
      this.play()
    } else if (this.loaded) {
      this.pause()
    }

    this.element.classList.toggle('is-hidden', !this.isAllowed())
  }

  load () {
    this.loaded = true

    this.element.addEventListener('playing', () => this.element.classList.add('is-playing'), { once: true })
    this.element.muted = true
    this.element.src = this.element.getAttribute('data-src')
  }

  play () {
    const promise = this.element.play()
    if (promise) {
      promise.catch(() => {})
    }
  }

  pause () {
    this.element.pause()
  }
}

export default function CoverSectionVideo () {
  document.querySelectorAll('.js-cover-video').forEach((element) => new CoverVideo(element))
}
